import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import { ICardElementWithChildren } from "backend/model/model";
import { t } from "i18next";
import React from "react";

const WorkflowElementState = (props: { item?: ICardElementWithChildren }) => {
  const { item } = props;

  if (!item?.workflowInstance) return null;
  const wf = item?.workflowInstance;

  const escalation = wf.escalations?.find(
    (esc) => esc.state === wf.currentState
  );

  if (escalation) {
    return (
      <Alert severity="error">
        {t("Workflow was escalated")}
        <AlertTitle>{escalation.message}</AlertTitle>
      </Alert>
    );
  }

  switch (wf.currentState as string) {
    case "approval":
      return null;
    case "approvalrejected":
      return (
        <Alert severity="warning">
          {t("Approval was rejected")}
          <AlertTitle>{wf.latestLog?.message || ""}</AlertTitle>
        </Alert>
      );
    case "finalapproval":
      return null;
    case "dataentry":
      return null;
    case "finalapprovalrejected":
      return (
        <Alert severity="warning">
          {t("Final Approval was rejected")}
          <AlertTitle>{wf.latestLog?.message || ""}</AlertTitle>
        </Alert>
      );
  }
  return null;
};

export default WorkflowElementState;
